// import { CreateUserInput, LoginInput, UserResponse } from '../../models/core/user';
// import { CreateStudentInput } from '../../models/core/student';
// import { create } from 'zustand';

type StorageKey = 'users' | 'currentUser' | 'students' | 'loginAttempts';

export const StorageService = {
  // Base methods stay synchronous
  read: (key: StorageKey) => JSON.parse(localStorage.getItem(key) || '[]'),
  find: (key: StorageKey) => localStorage.getItem(key),
  write: (key: StorageKey, value: any) => localStorage.setItem(key, JSON.stringify(value)),
  delete: (key: StorageKey) => localStorage.removeItem(key),

  async get(db: StorageKey, identifier: string): Promise<any> {
    const items = this.read(db);
    return items.find((item: any) => item._id === identifier || item.email === identifier) || null;
  },

  async create(db: StorageKey, item: any) {
    const items = this.read(db);
    const newItem = {
      ...item,
      _id: `${db}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    items.push(newItem);
    this.write(db, items);
    
    return newItem; // Added a return so AuthService can access the created user
  },

  async update(db: StorageKey, identifier: string, updates: Partial<any>) {
    const items = this.read(db);
    const index = items.findIndex((u: any) => u._id === identifier || u.email === identifier);
    
    if (index === -1) return null;

    items[index] = {
      ...items[index],
      ...updates,
      updatedAt: new Date(),
    };

    this.write(db, items);
    return items[index]; // Return the updated item
  },

  async search(db: StorageKey, query: Partial<any>): Promise<any[]> {
    const items = this.read(db);
    return items.filter((item: any) => {
      return Object.entries(query).every(([key, value]) => item[key] === value);
    });
  }
}